import React, { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

export default function MaintenanceMode() {
  const [isHidden, setIsHidden] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [enabled, setEnabled] = useState(null); // null = chargement en cours
  const [loading, setLoading] = useState(true);

  // Récupérer l'état de maintenance depuis l'API au montage
  useEffect(() => {
    const fetchMaintenance = async () => {
      try {
        const response = await fetch(`${API_URL}/maintenance`);
        if (response.ok) {
          const data = await response.json();
          setEnabled(data.enabled);
        } else {
          console.error('Erreur lors de la récupération du statut de maintenance');
          setEnabled(false); // Par défaut, désactiver si erreur
        }
      } catch (error) {
        console.error('Erreur de connexion à l\'API maintenance:', error);
        setEnabled(false);
      } finally {
        setLoading(false);
      }
    };

    fetchMaintenance();
  }, []);

  useEffect(() => {
    if (!enabled) return;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Cacher uniquement quand on descend de plus de 100px
      if (currentScrollY > 100 && currentScrollY > lastScrollY) {
        setIsHidden(true);
      }
      // Réafficher quand on remonte
      else if (currentScrollY < lastScrollY || currentScrollY <= 100) {
        setIsHidden(false);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY, enabled]);

  if (!enabled || loading) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1500, // Au-dessus de la navbar (z-index 1400)
        background: '#c62828',
        color: 'white',
        textAlign: 'center',
        padding: '8px 20px',
        fontSize: '14px',
        fontWeight: 500,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        transition: 'transform 0.3s ease-in-out',
        transform: isHidden ? 'translateY(-100%)' : 'translateY(0)',
        height: '40px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
      }}
    >
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width="16" 
        height="16" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="2"
      >
        <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
      </svg>
      <span>
        <strong>Site en maintenance</strong> - Certaines fonctionnalités peuvent être temporairement indisponibles.
      </span>
    </div>
  );
}